import { isBrowser } from './config';

const isNotInitError = (e: unknown) =>
  e instanceof Error && e.message.includes('No instance of Session found');

const getSessionModule = async () => {
  // Keep your current import source (supertokens-auth-react) for now
  const mod = await import('supertokens-auth-react/recipe/session');
  return mod.default;
};

export const getSessionAccessToken = async (): Promise<string | null> => {
  if (!isBrowser()) return null;

  try {
    const Session = await getSessionModule();

    const exists = await Session.doesSessionExist();
    if (!exists) return null;

    const token = await Session.getAccessToken();
    return token || null;
  } catch (e) {
    // SuperTokens not initialised yet → treat as no session
    if (isNotInitError(e)) return null;
    throw e;
  }
};

export const getSessionTenantId = async (): Promise<string | null> => {
  if (!isBrowser()) return null;

  try {
    const Session = await getSessionModule();

    const exists = await Session.doesSessionExist();
    if (!exists) return null;

    const payload = await Session.getAccessTokenPayloadSecurely();
    const tId = (payload as { tId?: unknown } | null | undefined)?.tId;

    return typeof tId === 'string' && tId ? tId : null;
  } catch (e) {
    // SuperTokens not initialised yet → treat as no session
    if (isNotInitError(e)) return null;
    throw e;
  }
};
